<template>
    <div class="form-field form-field__bool" :class="[rootClasses]">
        <span class="form-field--title-label" v-if="label" v-text="label"></span>
        <div class="form-field--row">
            <div class="form-field--input-container" v-for="(item, idx) in uniqueItems">
                <input class="form-field--input"
                        :type="type"
                        v-bind="getInputAttrs(item)"
                        v-model="val"
                        :value="item.val"
                        @change="updateValue()">
                <label class="form-field--label-wrap" :for="item.id">
                    <span class="form-field--box">
                        <span v-if="type === 'radio'" class="form-field--box-icon"></span>
                        <cmp-icon v-if="type === 'checkbox'"  class="form-field--box-icon"
                                symbol="check" size="small">
                        </cmp-icon>
                    </span>
                    <span class="form-field--label"
                            v-text="item.label || item.val">
                    </span>
                </label>
            </div>
        </div>
        <cmp-form-field-messages-partial
                :messages="messages"
                :active-item="activeItem">
        </cmp-form-field-messages-partial>
    </div>
</template>

<script>
    import formFieldAbstractMixin from 'vue/mixins/form/form-field-abstract';
    import formFieldItemsMixin from 'vue/mixins/form/form-field-items';


    export default {
        mixins: [
            formFieldAbstractMixin,
            formFieldItemsMixin,
        ],
        props: {
            value: {
                type: [Array, String, Number, Boolean],
                required: true,
            },
            vertical: {
                type: Boolean,
            },
            multiline: {
                type: Boolean,
                default: true,
            },
            state: {
                type: Object,
                default() {
                    return {};
                },
            },
        },
        data() {
            return {
                val: this.value,
            };
        },
        computed: {
            isBooleanCheckbox() {
                return (this.type === 'checkbox') && (typeof this.value === 'boolean') && (this.items.length <= 1);
            },
            specificRootClasses() {
                return {
                    [`form-field__bool-facet-${ this.facet || 'base' }`]: true,
                    'form-field__vertical': this.vertical,
                    'form-field__multiline': this.multiline,
                };
            },
        },
        methods: {
            getInputAttrs(item) {
                const { name, id, state } = item;
                const { focus, hover, pseudoChecked, disabled } = state || {};
                const fieldState = this.rootClasses;

                return {
                    name,
                    id,
                    disabled: fieldState.disabled || disabled,
                    'data-focus': fieldState.focus || focus,
                    'data-hover': hover,
                    'data-checked': pseudoChecked,
                };
            },
            updateValue() {
                this.$emit('input', this.val);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?4ab43371